module.exports = __webpack_public_path__ + "static/ecounicorncomforter-187b72b3ec0342d2b11280e847ea88fb.jpeg";